import { useTranslation } from 'react-i18next';

export default function ValueSection() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          {/* Left: Value proposition */}
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-tight">
              {t('value_title')}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed">
              {t('value_desc')}
            </p>

            {/* Bullet points */}
            <ul className="mt-8 space-y-4">
              {[1, 2, 3, 4, 5].map((num) => (
                <li key={num} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-xs text-primary-600"></i>
                  </span>
                  <span className="text-sm md:text-base text-foreground-700">
                    {t(`value_bullet_${num}`)}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Comparison Table */}
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-5 md:p-6">
            <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-1">
              {t('comparison_title')}
            </h3>
            <p className="text-xs text-foreground-500 mb-5">
              {t('comparison_subtitle')}
            </p>

            <div className="overflow-x-auto">
              <table className="w-full text-xs md:text-sm">
                <thead>
                  <tr className="border-b border-background-200/70">
                    <th className="text-left py-3 pr-3 font-semibold text-foreground-800 whitespace-nowrap">{t('comparison_col_solution')}</th>
                    <th className="text-center py-3 px-2 font-semibold text-foreground-800 whitespace-nowrap">{t('comparison_col_ease')}</th>
                    <th className="text-center py-3 px-2 font-semibold text-foreground-800 whitespace-nowrap">{t('comparison_col_power')}</th>
                    <th className="text-center py-3 px-2 font-semibold text-foreground-800 whitespace-nowrap">{t('comparison_col_cost')}</th>
                    <th className="text-center py-3 px-2 font-semibold text-foreground-800 whitespace-nowrap">{t('comparison_col_seo')}</th>
                    <th className="text-center py-3 pl-2 font-semibold text-foreground-800 whitespace-nowrap">{t('comparison_col_recommended')}</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Row 1 - Hipobuy (highlighted) */}
                  <tr className="border-b border-background-200/50 bg-primary-50/50">
                    <td className="py-3 pr-3 font-semibold text-primary-700 whitespace-nowrap">
                      {t('comparison_row_1_solution')}
                    </td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_1_ease')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_1_power')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap text-primary-700 font-medium">{t('comparison_row_1_cost')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap text-primary-700 font-medium">{t('comparison_row_1_seo')}</td>
                    <td className="text-center py-3 pl-2 whitespace-nowrap">
                      <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs rounded-full font-medium">{t('comparison_row_1_recommended')}</span>
                    </td>
                  </tr>
                  {/* Row 2 - Excel */}
                  <tr className="border-b border-background-200/50">
                    <td className="py-3 pr-3 font-medium text-foreground-700 whitespace-nowrap">{t('comparison_row_2_solution')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_2_ease')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_2_power')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_2_cost')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_2_seo')}</td>
                    <td className="text-center py-3 pl-2 whitespace-nowrap text-foreground-500">{t('comparison_row_2_recommended')}</td>
                  </tr>
                  {/* Row 3 - Notion */}
                  <tr>
                    <td className="py-3 pr-3 font-medium text-foreground-700 whitespace-nowrap">{t('comparison_row_3_solution')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_3_ease')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_3_power')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_3_cost')}</td>
                    <td className="text-center py-3 px-2 whitespace-nowrap">{t('comparison_row_3_seo')}</td>
                    <td className="text-center py-3 pl-2 whitespace-nowrap text-foreground-500">{t('comparison_row_3_recommended')}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}